module.exports = __webpack_public_path__ + "img/no-brand-menu-picture.008a239a.svg";